import { useInfiniteQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';

import { FetchPostsInBoard } from '..';

const PAGE_SIZE = 20;

export function useInfinitePostsInBoard(boardId: string) {
  const queryKeys = useQueryKeys();

  return useInfiniteQuery({
    queryKey: queryKeys.board.infinitePosts(boardId, PAGE_SIZE),
    queryFn: ({ pageParam = 1, signal }) =>
      FetchPostsInBoard(
        boardId,
        {
          page: pageParam,
          limit: PAGE_SIZE,
        },
        signal,
      ),
    initialPageParam: 1,
    enabled: Boolean(boardId),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.posts.length < PAGE_SIZE) return undefined;
      return allPages.length + 1;
    },
  });
}
